<template>
  <div class='relative flex items-center px-2 border-b border-gray-200'>
    <div
      class="text-primary-heavy text-xl font-bold mx-6"
    >
      發布時間 {{ release_time }}
    </div>

    <div class="flex">
      <label
        v-for="datetime_index in fcst_datetime_index"
        :key="datetime_index"
        class="my-4 mx-2"
      >
        <input
          type="radio"
          v-model="datetime_selected_index"
          :value="datetime_index"
          class="peer sr-only"
        >
        <div class="radio_btn btn_primary--line">
          <span>{{ display_fcst_datetime(datetime_index) }}</span>
        </div>
      </label>
    </div>

    <button
      class="absolute right-0 vertical_center mx-6 btn_primary--line"
      @click="logout"
    >
      登出
    </button>
  </div>
</template>
<script>
import { MainVState } from '@/state/main'
import { UserVState } from '@/libs/cb-account/vstate'

export default {
  name: 'Navigator',

  data() {
    return {
      datetime_selected_index: 0
    }
  },

  computed: {
    release_time() {
      return MainVState.release_time.toLST().strftime("%H:%M")
    },
    fcst_datetime_index() {
      return [...Array(MainVState.fcst_datetime_list.length).keys()]
    }
  },

  methods: {
    display_fcst_datetime(datetime_index) {
      let fcst_datetime = MainVState.fcst_datetime_list[datetime_index]
      let fcst_period = MainVState.fcst_period_list[datetime_index]
      if (fcst_period == 12) {
        // 12小時預報
        if (fcst_datetime.getHours() == 0) {
          // 上午場
          return fcst_datetime.strftime("%m/%d(%-a) 上午")
        }
        else if (fcst_datetime.getHours() == 12) {
          // 下午場
          return fcst_datetime.strftime("%m/%d(%-a) 下午")
        }
      }
      return fcst_datetime.strftime("%m/%d(%-a)")
    },

    datetime_changed(datetime_selected_index) {
      this.datetime_selected_index = datetime_selected_index
      MainVState.set_fcst_datetime_selected(datetime_selected_index)
    },

    logout() {
      UserVState.logout()
      .then(() => {
        location.reload()
      })
      .catch(code => {
        alert('無法登出')
      })
    }
  },

  watch: {
    datetime_selected_index(val) {
      this.datetime_changed(val)
    }
  },

  mounted() {
  }
}
</script>
